




























import {chunk} from 'lodash-es';
import naja from 'naja';
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class EstateImagePicker extends Vue {
    @Prop({type: Array, required: true})
    public readonly images: EstateImage[];

    @Prop({type: Array, required: false, default: Array})
    public readonly picked: EstateImage[];

    @Prop({type: String, required: true})
    public readonly url: string;

    protected selectedImages: EstateImage[] = [];

    protected get imageChunks(): EstateImage[][] {
        return chunk(this.images, 4);
    }

    private readonly MAX_PICKED_COUNT = 6;

    public created(): void {
      const pickedIds = this.picked.map(image => image.id);

      this.selectedImages = this.picked.length > 0
          ? this.images.filter(image => pickedIds.includes(image.id))
          : this.images.slice(0, this.MAX_PICKED_COUNT);
    }

    protected togglePrimaryImage(image: EstateImage): void {
        if (! this.isSelected(image)) {
            alert('Primární obrázek musí být mezi vybranými obrázky');
            return;
        }
    }

    protected toggleSelectedImage(toggledImage: EstateImage): void {
        if (this.isSelected(toggledImage)) {
            this.selectedImages = this.selectedImages.filter(image => image.id !== toggledImage.id);

            return;
        }

        if (this.selectedImages.length >= this.MAX_PICKED_COUNT) {
            alert(`Vybrat můžete maximálně ${this.MAX_PICKED_COUNT} obrázků`);
            return;
        }

        this.selectedImages.push(toggledImage);
    }

    protected isSelected(image: EstateImage): boolean {
        return this.selectedImages.includes(image);
    }

    protected confirmSelection(): void {
        if (this.selectedImages.length === 0) {
            alert('Je třeba vybrat alespoň jednu fotografii');
            return;
        }

        if (this.selectedImages.length > this.MAX_PICKED_COUNT) {
            alert(`Vybrat můžete maximálně ${this.MAX_PICKED_COUNT} obrázků`);
            return;
        }

        const data = {
            selectedImages: JSON.stringify(this.selectedImages),
        };

        naja.makeRequest('POST', this.url, data);
    }
}

interface EstateImage {
    id: string;
    url: string;
}
